import React ,{useEffect,useState} from 'react'
import { useParams } from "react-router-dom";
import Student911TopMenu from "../studentInfo/student911topmenu"
import { getIdData } from "../../../lib/studentinfo";
import PageNotes from "../../pages/common/pagenotesnew";
import { useAuth } from "../../../usercontext";

export default function index() {
    let { slug } = useParams();
    const [studentInfo, setStudentInfo] = useState();
    const { profile, setProfile } = useAuth();

    async function GetStudentData() {
        const std = await getIdData(slug);
        setStudentInfo(std);
        console.log("std", std);   
      }

useEffect(() => {
    GetStudentData();
}, [slug])


  return (
    <>
      <Student911TopMenu slug={slug} activeMenu={"Sat"} />
      <PageNotes
        type={"Instructor"}
        pageName={"Sat"}
        studentId={slug}
        instructorId={profile.id}
      />
      <div className="settings-widget profile-details">
        <div className="settings-inner-blk p-0">
          <div className="col-md-12 vh-100">
            {studentInfo &&
              (studentInfo[0].satlink !== null ? (
                <iframe
                  style={{
                    width: "100%",
                    height: "100%",
                    overflow: "auto",
                  }}
                  src={studentInfo[0].satlink}
                ></iframe>
              ) : (
                <div className="d-flex justify-content-center">
                  <h1 className="mt-5">Coming Soon</h1>
                </div>
              ))}
          </div>
        </div>
      </div>
    </>
  );

}
